import { useAsyncCallback } from 'react-async-hook';
import { useInviteStore } from '../store/use-invite-store';
import { api } from './instance';
import { transformApiBooking } from './utils';

export function useReserveTime() {
  const { removeSlot, setInvite, invite } = useInviteStore();

  return useAsyncCallback(async (calendarSlotId) => {
    try {
      const skip =
        (invite.appointment?.calendarListSlotId ?? invite.appointment?.calendarSlotId) ===
        calendarSlotId;
      if (!skip) {
        const data = await api.auth
          .post('onlinebooking/confirm-appointment', {
            json: {
              bookingReference: invite.reference,
              calendarListSlotId: calendarSlotId,
            },
          })
          .json();
        const transformed = transformApiBooking(data);
        setInvite(transformed);
        return transformed;
      } else {
        return invite;
      }
    } catch (error) {
      console.log(error);
      // TODO: check error code before removing slot
      removeSlot(calendarSlotId);
      throw error;
    }
  });
}
